const authors = [
    {
        name: "Tim Tangonan",
        imageUrl: "tim-t.png",
        bio: "A JAMstack developer who uses GatsbyJS for his personal projects.",
        github: "https://github.com/timtangonan",
        twitter: "https://twitter/com/timtangonan"
    },
    {
        name: "Renfred Tangonan",
        imageUrl: "ren-t.png",
        bio: "A back-end developer who specializes in FaunaDB and Strapi.",
        github: "https://github.com/timtangonan",
        twitter: "https://twitter/com/timtangonan"
    }
]

module.exports = authors